import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-photography',
  templateUrl: './photography.component.html',
  styleUrls: ['./photography.component.scss']
})
export class PhotographyComponent implements OnInit {

  title = 'Photography | Bill\'s portfolio site';
  photography: Object;
  portrait: Object;
  landscape: Object;
  wedding: Object;
  events: Object;
  others: Object;
  total: any;
  objectKeys = Object.keys;
  public errorMsg;

  constructor(public router: Router,
    private titleService: Title, 
    private metaService: Meta, 
    private route: ActivatedRoute, 
    private _http: HttpService) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: 'robots', content: 'index, follow'}
    ]);
    this.metaService.updateTag({name: 'keywords', content: 'Photography'});
    this.metaService.updateTag({name: 'description', content: 'While Bill loves web development and design, his real passion lies in photography. Since his very first camera in 2003, Bill has dedicated his heart, effort and talents into continuously improving his skill in capturing the beauty and wonder that the world has to offer. With a keen eye for lighting, angle and framing; Bill truly understands how a properly taken photograph can capture the pure essence of a person, landscape or object.'});

    this._http.getPhotos('all',null).subscribe(
      data => {
        this.photography = data;
        this.portrait = data.filter((item) => { return item['item_category'] === 'Portrait'});
        this.landscape = data.filter((item) => { return item['item_category'] === 'Landscape'});
        this.wedding = data.filter((item) => { return item['item_category'] === 'Wedding'});
        this.events = data.filter((item) => { return item['item_category'] === 'Events'});
        this.others = data.filter((item) => { return item['item_category'] === 'Others'});
        // console.log(this.photography);
        this.total = Object.keys(data).length;
      },
      error => this.errorMsg = error      
    );
  }

  onSelect(item) {
    // this.router.navigate(['/list', brew.id]); // Absolute url
    this.router.navigate([item.url, {type: item.item_category, postType: 'photography'}], {relativeTo: this.route}); // relative url
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1500,
    navText: ['<', '>'],
    autoplay:true,
    animateIn: 'fadeIn', 
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1 
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  }
}
